module.exports = "<lc-navigation-bar [background]=\"'background--none'\"></lc-navigation-bar>\n\n<lc-content-block *ngFor=\"let block of contentblocks\" [block]=\"block\">\n  \n</lc-content-block>\n\n<lc-footer-bar></lc-footer-bar>"


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/expert-cleanpage/expert-cleanpage.component.html
// module id = ../../../../../src/app/pages/expert-cleanpage/expert-cleanpage.component.html
// module chunks = main